import { useSyncExternalStore } from 'react';

// Un 502 o 504 dal proxy vuol dire che poptown-api si sta aggiornando (o è giù): la plancia lo
// dice con la sua schermata d'attesa invece di mostrare errori sparsi. Il 503 no: è una
// risposta dell'app (es. SurgeAI occupato in un addestramento) e passa intatto.
const GATEWAY = new Set([502, 504]);
let updating = false;
const listeners = new Set<() => void>();

export function noteStatus(status: number): void {
  if (!GATEWAY.has(status) || updating) return;
  updating = true;
  listeners.forEach((l) => l());
}

export function useUpdating(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => updating,
  );
}

// Un 401 su una chiamata qualunque: la sessione è scaduta o chiusa (password cambiata da un
// altro browser). La plancia torna al login invece di restare nella shell con ogni azione in
// errore.
const unauthorized = new Set<() => void>();

export function noteUnauthorized(): void {
  unauthorized.forEach((l) => l());
}

export function onUnauthorized(listener: () => void): () => void {
  unauthorized.add(listener);
  return () => unauthorized.delete(listener);
}
